




















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/kuntama/PopupTemplate.vue'
import QuizKuntama from '@/views/organisms/QuizKuntama.vue'

export default
  components: {
    PopupTemplate
    QuizKuntama
  }

  data: () ->
    baseColor: '#E0B48E'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        '燻製窯の温度は、何度に保っているでしょうか？'
      ]
      quiz: [
        '45～50℃'
        '50～55℃'
        '55～60℃'
      ]
      success_message: [
        '朝5時と夕方5時の一日2回チップをくべて、'
        '窯の温度を45～50℃に保っているよ。'
      ]
      answer: 1

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p4-14'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
      @$emit('success')
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
